import React, { useState, useEffect, useCallback } from 'react';
import placeholderImage from '../assets/icons/Sed-01-512.png';
import Time from '@material-ui/icons/AccessTime';

import { useSelector, useDispatch } from 'react-redux';
import { db } from '../config/firebaseInitial';
import Location from '@material-ui/icons/RoomOutlined';
import firebase from 'firebase/app';
import Modal from './Modal';
import MapModale from './MapModal';
import { popupLoc } from '../redux/actions/DashboardActions';

const Card = ({ cardInfo, cardId, fromPage }) => {
  const dispatch = useDispatch();

  const [checkedNeeds, setCheckedNeeds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isChecked, setIsChecked] = useState({});
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const currentUser = useSelector((state) => state.authReducer.userId);
  const [isCardOpen, setIsCardOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fillCheckedNeeds = () => {
    let needsCheck = {};
    Object.keys(cardInfo.needs).map((key) => {
      needsCheck[key] = false;
    });
    return needsCheck;
  };

  useEffect(() => {
    setIsChecked(fillCheckedNeeds());
  }, []);

  const toggel = () => {
    isAuthenticated ? setIsCardOpen(!isCardOpen) : setIsModalOpen(true);
  };

  const doesWorkerExist = () =>
    !!cardInfo.workerCard.find((item) => item[currentUser]);

  const isWorkerDone = () =>
    !!cardInfo.workerCard.find((item) => item[currentUser] === 'Done');

  const removeNeedsFromUser = () => {
    var batch = db.batch();
    let needDoc = db.collection('cards').doc(cardId);
    checkedNeeds.map((item) => {
      if (fromPage === 'UserActivities' && item.status === 'completed') {
        batch.update(needDoc, {
          [`needs.${item.indexCB}.needStatus`]: 'pending',
          [`needs.${item.indexCB}.uid`]: '',
        });
      }
    });

    setCheckedNeeds([]);
    batch
      .commit()
      .then(function () {})
      .catch(function (error) {});
  };

  const updateNeedsFirestore = () => {
    var batch = db.batch();
    let needDoc = db.collection('cards').doc(cardId);

    checkedNeeds.map((item) => {
      if (
        (fromPage === 'Dashboard' && item.status === 'inprogress') ||
        (fromPage === 'UserActivities' && item.status === 'completed')
      ) {
        batch.update(needDoc, {
          [`needs.${item.indexCB}.needStatus`]: item.status,
          [`needs.${item.indexCB}.uid`]: currentUser,
        });
      }
    });
    alert('تم الاستلام');
    if (!doesWorkerExist()) {
      batch.update(needDoc, {
        workerCard: firebase.firestore.FieldValue.arrayUnion({
          [currentUser]: 'WorkingOnIt',
        }),
      });

      batch.update(needDoc, {
        [`workerCardTime.${currentUser}`]: firebase.firestore.FieldValue.serverTimestamp(),
      });
    } else if (isWorkerDone()) {
      let workers = cardInfo.workerCard;
      let worker = workers.findIndex((item) => item[currentUser] === 'Done');
      workers[worker] = { [currentUser]: 'WorkingOnIt' };
      batch.update(needDoc, {
        [`workerCardTime.${currentUser}`]: firebase.firestore.FieldValue.serverTimestamp(),
      });
      batch
        .update(needDoc, {
          workerCard: workers,
        })
        .catch((error) => {});
    }
    setCheckedNeeds([]);
    batch
      .commit()

      .then(function () {})
      .catch(function (error) {});
  };
  const createCheckBoxForDashboard = (needItem, key) =>
    needItem.needStatus === 'pending' && needItem.uid === '' ? (
      <label
        key={key + cardId}
        className='inline-block bg-white need px-2 m-1 n-blue border  rounded-md text-sm '
      >
        <div className='flex items-center'>
          {needItem.theNeed}
          <input
            type='checkbox'
            className='mx-1 mt-1 radial-check'
            onChange={(e) => {
              let need = checkedNeeds;
              need[key] = {
                status: e.target.checked ? 'inprogress' : 'pending',
                indexCB: key,
              };
              setCheckedNeeds(need);
            }}
            checked={isChecked[key] || false}
            onClick={() =>
              setIsChecked((prev) => ({ ...prev, [key]: !isChecked[key] }))
            }
          />
          <span className='checkmark'></span>
        </div>
      </label>
    ) : needItem.needStatus === 'inprogress' ||
      needItem.needStatus === 'completed' ? (
      <div
        key={key + cardId}
        className='inline-block lal border-gray-500 mx-1 my-1 px-2 n-blue border rounded-lg text-sm  '
      >
        <div className='flex items-center'>
          <div className='tooltip text-gray-800'>
            {needItem.theNeed}
            <span className='tooltiptext '>تم التوصيل</span>
          </div>

          <input
            type='checkbox'
            className='mx-1 mt-1 radial-check'
            disabled
            checked
          />
          <span className='checkmark-fixed'></span>
        </div>
      </div>
    ) : null;

  const createCheckBoxForProfile = (needItem, key) =>
    needItem.needStatus === 'inprogress' && needItem.uid === currentUser ? (
      <label
        key={key + cardId}
        className='inline-block bg-white mx-2 my-1 px-2 n-blue border py-1 rounded-lg text-sm '
      >
        <div className='flex items-center'>
          {needItem.theNeed}
          <input
            type='checkbox'
            className='mx-1 mt-1 radial-check'
            onChange={(e) => {
              let need = checkedNeeds;
              need[key] = {
                status: e.target.checked ? 'completed' : 'inprogress',
                indexCB: key,
              };
              setCheckedNeeds(need);
            }}
            checked={isChecked[key] || false}
            onClick={() =>
              setIsChecked((prev) => ({ ...prev, [key]: !isChecked[key] }))
            }
          />
          <span className='checkmark'></span>
        </div>
      </label>
    ) : needItem.needStatus === 'completed' ? (
      <div
        key={key + cardId}
        className='inline-block bg-white mx-2 my-1  px-2 n-blue border py-1 rounded-lg text-sm  '
      >
        <div className='flex items-center'>
          <div className='tooltip'>
            {needItem.theNeed}
            <span className='tooltiptext'>تم التوصيل</span>
          </div>

          <input
            type='checkbox'
            className='mx-1 mt-1 radial-check'
            disabled
            checked
          />
          <span className='checkmark-fixed'></span>
        </div>
      </div>
    ) : null;
  const [mapModel, setMapModel] = useState(false);

  const showMapModel = useCallback(() => {
    setMapModel(!mapModel);
    dispatch(popupLoc(cardInfo.location));
  }, []);

  const converDate = (timestamp) => {
    if (timestamp) {
      let fireTime = new Date(timestamp.toDate());

      let newDate = new Date();

      let elaps = (newDate.getTime() - fireTime.getTime()) / 1000;
      if (elaps > 86400) {
        return Math.floor(elaps / 86400) + ' أيام';
      } else if (elaps > 3600) {
        return Math.floor((elaps / 3600) % 24) + ' ساعات';
      } else if (elaps > 60) {
        return Math.floor((elaps / 60) % 60) + ' دقائق';
      } else {
        return Math.floor(elaps % 60) + ' ثواني';
      }
    }
  };
  const isAnyButtonChecked = () =>
    Object.keys(isChecked).some((key) => isChecked[key] === true);
  return (
    <>
      <div
        className={`inline-block relative bg-dark-blue font-normal w-full sm:w-2/4 md:w-2/5 lg:w-3/12   
        text-white text-right  my-3 lg:my-2 lg:mx-2 mx-3 w-card-min ${
          isCardOpen ? '' : ''
        }`}
      >
        <div className=' flex flex-row justify-end relative px-2 pt-4 pb-4'>
          <div className='mt-4 '>
            <div className='flex justify-between '>
              <span className='flex mx-4 px-2 text-xs absolute left-0'>
                <Time alt='time' className='w-4' fontSize='small' />

                <p className='pt-1 ml-2'>
                  منذ {converDate(cardInfo.timestamp)}
                </p>
              </span>
            </div>

            {isAuthenticated ? (
              <div className='mx-2'>
                <span className='block'> {cardInfo.name}</span>
                <span
                  className={` mt-1 cursor-pointer block ${
                    isCardOpen ? ' ' : 'hidden'
                  } `}
                  onClick={() => {
                    showMapModel();
                  }}
                >
                  <Location
                    className='mx-1 mt-0 inline-block'
                    alt='location'
                    fontSize='small'
                  />
                  {cardInfo.prov}
                </span>
                <span className={`block  ${isCardOpen ? ' ' : 'hidden'} `}>
                  رقم الهاتف : {cardInfo.phoneNumber}
                </span>
              </div>
            ) : null}
          </div>
          <div className='h-16 ml-2 mb-2'>
            <img
              src={placeholderImage}
              alt='person'
              className={`img-w-24 mr-2 ${isCardOpen ? 'mt-4' : ''}`}
            />
          </div>
        </div>
        <hr className={` ${isCardOpen ? 'mt-1 mb-2 mx-6 w-auto' : 'hidden'}`} />
        <div className='relative'>
          <div
            className={`relative block scrolling-touch overflow-x-hidden
           scrollbar-thumb-card px-4 pt-3 mx-8 ${
             isCardOpen
               ? 'overflow-y-auto need-space '
               : 'overflow-y-hidden h-32'
           }`}
          >
            <p
              className={`${
                isCardOpen
                  ? ' text-left text-sm -ml-4 -mt-2 cursor-pointer font-bold '
                  : 'hidden'
              } `}
              onClick={() => {
                setSelectAll((prev) => !prev);
                Object.keys(isChecked).map((key) =>
                  setIsChecked((prev) => ({ ...prev, [key]: !selectAll }))
                );
                let tempArr = [];
                Object.keys(cardInfo.needs).map((key) => {
                  tempArr[key] = {
                    status:
                      fromPage === 'Dashboard'
                        ? !selectAll
                          ? 'inprogress'
                          : 'pending'
                        : fromPage === 'UserActivities'
                        ? !selectAll
                          ? 'completed'
                          : 'inprogress'
                        : null,
                    indexCB: key,
                  };
                });
                setCheckedNeeds(tempArr);
              }}
            >
              {!selectAll ? 'تحديد الكل' : 'الغاء تحديد الكل'}
            </p>
            <span className=''>
              {fromPage === 'Dashboard'
                ? Object.keys(cardInfo.needs).map((key) =>
                    createCheckBoxForDashboard(cardInfo.needs[key], key)
                  )
                : fromPage === 'UserActivities'
                ? Object.keys(cardInfo.needs).map((key) =>
                    createCheckBoxForProfile(cardInfo.needs[key], key)
                  )
                : null}
            </span>
          </div>
          {!isCardOpen ? (
            <div
              className={`absolute bottom-0 card-gradient h-4 w-full z-30`}
            ></div>
          ) : null}
        </div>

        <div className={` bg-dark-bottom  rounded-b-lg px-4 pb-4`}>
          <div>
            {fromPage === 'Dashboard' ? (
              <div>
                <span className='flex items-center '>
                  <button
                    onClick={toggel}
                    className={`need flex items-center bg-white n-blue px-4 pt-1 focus:outline-none
                    mt-4 ml-2 text-sm ${isCardOpen ? 'hidden' : 'flex'}`}
                  >
                    اعرض المزيد
                  </button>
                </span>

                <span
                  className={`flex items-center ${
                    isCardOpen ? 'flex' : 'hidden'
                  }`}
                >
                  <button
                    onClick={toggel}
                    className={` flex items-center bg-white n-blue px-4 pt-1 focus:outline-none
                  mt-4 ml-1 need text-sm`}
                  >
                    اعرض اقل
                  </button>

                  <button
                    className='flex items-center bg-white n-blue px-4 pt-1 
                  mt-4 ml-2 need text-sm focus:outline-none tooltip'
                    onClick={
                      checkedNeeds.length > 0 ? updateNeedsFirestore : null
                    }
                  >
                    <span className='tooltiptext'>حدد الاحتياجات</span>
                    اضافة
                  </button>
                </span>

                {isModalOpen ? (
                  <Modal setIsModalClose={setIsModalOpen} />
                ) : null}
              </div>
            ) : (
              <div>
                <span className='flex items-center'>
                  <button
                    onClick={toggel}
                    className={`need flex items-center bg-white n-blue px-4 pt-1 focus:outline-none
                  mt-4 ml-1 text-sm ${isCardOpen ? 'hidden' : 'flex'}`}
                  >
                    اعرض المزيد
                  </button>
                </span>
                {isModalOpen ? <Modal /> : null}
                <span
                  className={`flex items-center ${
                    isCardOpen ? 'flex' : 'hidden'
                  }`}
                >
                  <button
                    onClick={toggel}
                    className={` flex items-center bg-white n-blue px-4 lg:px-2 xl:px-4 pt-1 focus:outline-none
                  mt-4 ml-1 need text-sm`}
                  >
                    اعرض اقل
                  </button>
                  <button
                    className={`flex items-center  text-white px-3 sm:px-4 lg:px-2 xl:px-4 pt-1 focus:outline-none
                  mt-4 ml-2 need text-sm ${
                    isAnyButtonChecked()
                      ? 'bg-red-400 hover:bg-red-500'
                      : 'bg-gray-500'
                  }`}
                    onClick={removeNeedsFromUser}
                    disabled={
                      !Object.keys(isChecked).some(
                        (key) => isChecked[key] === true
                      )
                    }
                  >
                    <div className='tooltip'>
                      الغاء
                      <span className='tooltiptext'>هل انت متأكد؟</span>
                    </div>
                  </button>
                  <button
                    className={`flex items-center  text-white px-3 lg:px-2 xl:px-4 pt-1 focus:outline-none
                   mt-4 ml-2 need text-sm ${
                     isAnyButtonChecked()
                       ? 'bg-green-400 hover:bg-green-500'
                       : 'bg-gray-500'
                   }`}
                    onClick={updateNeedsFirestore}
                    disabled={!isAnyButtonChecked()}
                  >
                    <div className='tooltip'>
                      تم التوصيل
                      <span className='tooltiptext'>هل انت متأكد ؟</span>
                    </div>
                  </button>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      {mapModel ? (
        <MapModale mapModelProp={mapModel} setMapModel={setMapModel} />
      ) : null}
    </>
  );
};
const checkEquality = (prevCard, NextCard) =>
  JSON.stringify(prevCard) === JSON.stringify(NextCard);
export default React.memo(Card, checkEquality);
